export default function RailsUtilsFactory(
    userService,
    l10nService,
    ukrailCardsService
) {
    'ngInject';

    return {

            makeTravellersOptions: function(text, number, includeZero) {
                const options = [];
                const start = includeZero ? 0 : 1;
                for (let i = start; i <= number; i++) {
                    if (text === 'Child') {
                        options.push({
                            text: i + ' ' + (
                                i > 1 ? l10nService.localize(text + 'ren') : l10nService.localize(text)),
                            value: i.toString(),
                        });
                    } else {
                        options.push({
                            text: i + ' ' + (
                                i > 1 ? l10nService.localize(text + 's') : l10nService.localize(text)),
                            value: i.toString(),
                        });
                    }
                }
                return options;
            },

            departureTimeWatcher: function(DepartureDate, DepartTimeOptions, DepartTimeSelected, timeOptions) {
                const regionalSettings = userService.getRegionalSettings();
                const departDate = moment(DepartureDate, regionalSettings.dateFormat);
                const now = moment();
                const minHour = now.hour();
                if (departDate.isValid() && departDate.isSame(now, 'day')) {
                    const filteredDepartTimeOptions = _.filter(angular.copy(timeOptions), function(item) {
                        return minHour <= item.startHour;
                    });

                    replaceArray(DepartTimeOptions, filteredDepartTimeOptions);

                    if (!_.find(filteredDepartTimeOptions, DepartTimeSelected)) {
                        _.assign(DepartTimeSelected, DepartTimeOptions[0]);
                    }
                } else {
                    replaceArray(DepartTimeOptions, angular.copy(timeOptions));
                }
            },

            refreshReturnedDate: function() {
                if (!this[0]._date) {
                    return;
                }

                const regionalSettings = userService.getRegionalSettings();
                const departDate = moment(this[0]._date, regionalSettings.dateFormat);
                const returnDate = moment(this[1]._date, regionalSettings.dateFormat);

                if (departDate.isAfter(returnDate)) {
                    this[1]._date = null;
                }
            },

            returnTimeWatcher: function(DepartureDate,
                                         ReturnDate,
                                         ReturnTimeOptions,
                                         DepartTimeSelected,
                                         ReturnTimeSelected,
                                         timeOptions) {
                const regionalSettings = userService.getRegionalSettings();
                const departDate = moment(DepartureDate, regionalSettings.dateFormat);
                const returnDate = moment(ReturnDate, regionalSettings.dateFormat);
                const now = moment();
                let minHour = DepartTimeSelected.startHour;
                if (minHour === 24) {
                    minHour = 0;
                }
                if (minHour === 0 && returnDate.isSame(now, 'day')) {
                    minHour = now.hour();
                }

                if (returnDate.isValid() && departDate.isValid() && returnDate.isSame(departDate, 'day')) {
                    const filteredReturnTimeOptions = _.filter(angular.copy(timeOptions), function(item) {
                        return item.startHour >= minHour;
                    });
                    replaceArray(ReturnTimeOptions, filteredReturnTimeOptions);

                    if (!_.find(filteredReturnTimeOptions, ReturnTimeSelected)) {
                        _.assign(ReturnTimeSelected, ReturnTimeOptions[0]);
                    }
                } else {
                    replaceArray(ReturnTimeOptions, timeOptions);
                }
            },

            moreOptionsApplied: function(search) {
                const noneGoViaOrAvoid = 'None';

                return search.passengersRailcards && _.some(search.passengersRailcards, (passengerCards) => passengerCards.cards.length > 0)
                    || ukrailCardsService.railcardsApplied(search.ukRailCards)
                    || search.DirectRailsOnly
                    || search.GoViaOrAvoid.Value === noneGoViaOrAvoid;
            },

            hasOperator: function(flights) {
                let foundOperator = false;

                angular.forEach(
                    flights, function(flight) {
                        if (!foundOperator && flight.OperatingCompanyName) {
                            foundOperator = true;
                        }
                    }
                );

                return foundOperator;
            },

            getOperator: function(flights) {
                const airlines = [];
                let operatedBy = '';
                const MULTIPLE_OPERATORS = 'multiple airlines';

                angular.forEach(
                    flights, function(flight) {
                        if (flight.OperatingCompanyName && airlines.indexOf(flight.OperatingCompanyName) < 0) {
                            airlines.push(flight.OperatingCompanyName);

                            if (!operatedBy) {
                                operatedBy = flight.OperatingCompanyName;
                            }
                        }
                    }
                );

                return (airlines.length > 1) ? MULTIPLE_OPERATORS : operatedBy;
            },

            isSameAirportCheckNeeded,
            checkSameAirports,
            checkGroupSameAirports,
            calculateRoute,
            calculateDates,
            isRoundTripFlight,
            isMultiTripFlight,
            isRoundTripOrMultiTripFlight,
            prepareRulesLink,
            convertHoursToString,

            /**
             * Get flight stop
             */
            findFlightStop: function(flightGroup, stopCity) {
                return _.findWhere(flightGroup.FlightStops, {City: stopCity});
            },

            /**
             * Find DESTINATION city for multiflights
             */
            findDestination: function(rails) {
                let lastArrivalDate;
                let lastCity = '';
                let i = 0;
                const delay = [];

                _.each(rails, function(rail, index, list) {
                        if (index === list.length - 1) {
                            delay[i] = {
                                stayingTime: new Date(rail.DepartureDate) - new Date(lastArrivalDate),
                                city: lastCity,
                            };
                            i++;
                            lastArrivalDate = rail.ArrivalDate;
                            lastCity = rail.ArrivalStation;
                        }
                    });

                return _.max(delay, function(element) {
                    return element.stayingTime;
                }).city;
            },

            firstRail: (rail) => {
                return _.chain(rail)
                    .get('RailGroups').first()
                    .get('Rails').first()
                    .value();
            },

            lastRail: (rail) => {
                return _.chain(rail)
                    .get('RailGroups').last()
                    .get('Rails').last()
                    .value();
            },

            // TODO: is it same?
            lastFlightDetector: function(rail) {
                return _.chain(rail.FlightSegments).last()
                    .result('FlightGroups').last()
                    .result('Flights').last()
                    .value();
            },

            /**
             * Find first and last flights in Flight-item of trip
             */
            firstLastFlight: function(rail) {
                return {
                    first: rail.Rails[0],
                    last: this.lastRail(rail),
                };
            },

            /**
             * Determine flight type
             */
            railType: function(rail) {

                const characteristic = this.lastRail(rail).Direction;
                let type = (characteristic === 1) ? 'round' : 'multi';
                type = (characteristic === 0) ? 'single' : type;

                return type;
            },

            getRoute: function(rail, separator) {
                const firstPoint = this.firstRail(rail).DepartureStation;
                const lastPoint = this.lastRail(rail).ArrivalStation;
                let destination = null;
                const railsCount = rail.RailGroups.reduce((sum, railGroup) => sum + railGroup.Rails.length, 0);
                if (railsCount === 1) {
                    destination = lastPoint;
                }
                if (railsCount === 2) {
                    destination = this.lastRail(rail).DepartureStation + separator + lastPoint;
                }
                if (railsCount > 2) {
                    destination = this.findDestination(rail.Rails) + separator + lastPoint;
                }
                return firstPoint + separator + destination;
            },

            getFlightGroupsDaysShift: function(flightGroup) {
                const dDate = moment(flightGroup.Flights[0].DepartureDate, 'YYYY-MM-DD');
                const aDate = moment(flightGroup.Flights[flightGroup.Flights.length - 1].ArrivalDate, 'YYYY-MM-DD');
                let diff = aDate.diff(dDate, 'days');

                if (diff > 0) {
                    diff = '+' + diff;
                } else if (diff < 0) {
                    diff = '' + diff;
                }

                return diff;
            },

            findAmadeusFlights: function(tripDetails) {
                return _.filter(tripDetails.Flights, function(item) {
                    if (item && item.ServiceOption) {
                        return item.ServiceOption.Id === 1;
                    }
                    return false;
                });
            },

            isItemTrain: function() {
                return 'Train';
            },
            getFlightOrTrain,
        };

        function calculateDates(segs, railType, isOpenReturn) {
            const regionalSettings = userService.getRegionalSettings();
            const dates = [];
            let limit = 0;
            if (railType === 'roundtrip') {
                if (!isOpenReturn) {
                    limit = 1;
                }
            }
            for (let i = 0; i <= limit; i++) {
                if (segs[i]._date) {
                    dates.push(moment(segs[i]._date, regionalSettings.dateFormat)
                        .format(regionalSettings.fullDayMonDateYearFormat));
                }
            }

            if (isOpenReturn) {
                return dates[0];
            }

                return dates.join(' — ');


        }

        function calculateRoute(segments, flightType) {
            const segs = angular.copy(segments);

            let route = '';

            if (segs[0]._departure) {
                route += segs[0]._departure.DisplayString + ' → ' + segs[0]._arrival.DisplayString;
            }

            if (['roundtrip'].indexOf(flightType) !== -1 && segs[0]._departure.Code) {
                route = segs[0]._departure.DisplayString + ' ⇄ ' + segs[0]._arrival.DisplayString;
            }

            return route;
        }

        function isRoundTripFlight(flightType) {
            return flightType === 'roundtrip';
        }

        function isMultiTripFlight(flightType) {
            return flightType === 'multitrip';
        }

        function isRoundTripOrMultiTripFlight(flightType) {
            return isRoundTripFlight(flightType) || isMultiTripFlight(flightType);
        }

        function checkGroupSameAirports(flightGroup, segmentIndex, departureBlock) {
            const segmentsData = [];

            angular.forEach(flightGroup, function(group) {
                segmentsData.push(group.Flights[0]);
            });

            return checkSameAirports(segmentsData, segmentIndex, departureBlock);
        }

        function checkSameAirports(flightSegments, segmentIndex, isDepartureBlock) {
            return isSameAirportCheckNeeded(flightSegments, isDepartureBlock, segmentIndex)
                ? checkForSameAirportsNames() : false;

            function checkForSameAirportsNames() {
                if (segmentIndex === 0) {
                    if (isDepartureBlock) {
                        return flightSegments[0].DepartureAirport !== flightSegments[flightSegments.length - 1].ArrivalAirport;
                    }
                        return flightSegments[0].ArrivalAirport !== flightSegments[flightSegments.length - 1].DepartureAirport;

                }
                    if (isDepartureBlock) {
                        return flightSegments[0].ArrivalAirport !== flightSegments[flightSegments.length - 1].DepartureAirport;
                    }
                        return flightSegments[0].DepartureAirport !== flightSegments[flightSegments.length - 1].ArrivalAirport;


            }
        }
        function isSameAirportCheckNeeded(flightSegments, isDepartureBlock, segmentIndex) {

            /**
             * Don't highlight airport for oneway or multiply flights
             */
            if (flightSegments.length !== 2) {
                return false;
            }

            /**
             * (temporary) Don't highlight flight stops
             */
            return !(segmentIndex !== 0 && segmentIndex !== (flightSegments.length - 1));
        }

        function getFlightOrTrain(flight) {
            return flight.Airplane === 'Train' ? 'Train' : 'Flight';
        }

        function prepareRulesLink(flight, fareId, flightGroupIndexes, travellers, searchId) {
            const groupIds = [];
            angular.forEach(
                flightGroupIndexes, function(groupIndex, segmentIndex) {
                    const flightGroup = flight.FlightSegments[segmentIndex].FlightGroups[groupIndex];

                    if (flightGroup) {
                        groupIds.push(flightGroup.FlightGroupId);
                    }
                }
            );

            return {
                fare: flight.FareRecommendations[fareId].FareRecommendationGuid,
                recommendation: flight.RecommendationId,
                search: searchId,
                adult: _.has(travellers.Adult, 'value') ? travellers.Adult.value : travellers.Adult.length,
                child: _.has(travellers.Child, 'value') ? travellers.Child.value : travellers.Child.length,
                infant: _.has(travellers.Infant, 'value') ? travellers.Infant.value : travellers.Infant.length,
                groups: groupIds,
                culture: userService.getCulture(),
            };
        }

        function replaceArray(source, target) {
            Array.prototype.splice.apply(source, [0, source.length].concat(target));
        }
        function convertHoursToString(hours) {
           return hours < 10 ? `0${hours}` : `${hours}`;
        }
    }



// WEBPACK FOOTER //
// ./src/app/modules/base/services/railsUtils.js